import { DataGridTable } from "@shared/ui/DataGridTable";
import type { GridColDef } from "@mui/x-data-grid";
import type { TFunction } from "i18next";

import { dollarUS } from "@shared/utils/moneyFormat";

// x-data-grid Community no tiene footer de agregación. Como esta tabla de detalle
// tiene sorting y paginación deshabilitados, agregamos una fila "Total" sintética
/** Fila de la tabla de detalles: los del contrato mas la fila de totales que se agrega aca. */
type DetailRow = Record<string, unknown>;

export interface TableDetailsProps {
  details?: DetailRow[];
  t: TFunction;
}

// fijada al final y en negrita — mismo resultado que el viejo
// customTableBodyFooterRender, alineado por columna.
const withTotalsRow = (details?: DetailRow[]): DetailRow[] => {
  const rows = details || [];
  if (rows.length === 0) return rows;
  const sum = (key: string) => rows.reduce((acc: number, d: DetailRow) => acc + (Number(d[key]) || 0), 0);
  return [
    ...rows,
    {
      id: "__total__",
      __isTotal: true,
      reference: "Total",
      description: "",
      units: sum("units"),
      unitPrice: sum("unitPrice"),
      subtotal: sum("subtotal"),
      iva: sum("iva"),
      total: sum("total"),
    },
  ];
};

const money = (value?: number | null) => (value == null ? "" : dollarUS.format(value));

export const TableDetails = ({ details, t }: TableDetailsProps) => {
  const columns: GridColDef[] = [
    { field: "reference", headerName: t("reference"), flex: 1, sortable: false, filterable: false },
    { field: "description", headerName: t("article"), flex: 1, sortable: false, filterable: false },
    { field: "units", headerName: t("units"), flex: 1, sortable: false, filterable: false },
    {
      field: "unitPrice",
      headerName: t("unitPrice"),
      flex: 1,
      sortable: false,
      filterable: false,
      valueFormatter: money,
    },
    {
      field: "subtotal",
      headerName: t("subTotal"),
      flex: 1,
      sortable: false,
      filterable: false,
      valueFormatter: money,
    },
    { field: "iva", headerName: "% IVA", flex: 1, sortable: false, filterable: false },
    {
      field: "total",
      headerName: t("totalWithIVA"),
      flex: 1,
      sortable: false,
      filterable: false,
      valueFormatter: money,
    },
  ];

  return (
    <DataGridTable
      rows={withTotalsRow(details)}
      columns={columns}
      toolbar={false}
      pagination={false}
      getRowClassName={(params) => (params.row.__isTotal ? "datagrid-total-row" : "")}
      sx={{ "& .datagrid-total-row": { fontWeight: "bold" } }}
    />
  );
};
